/* ============================================================
   COVRFLY — Menu Móvil Premium v17.7 · Shopify Permanent
   ARCHITECTURE: "Body Portal" (consensus GPT + Gemini + Claude)
   Audited: 6 rounds, 16 fixes
   ============================================================ */

(function () {
  'use strict';

  /* ========= CLOSE TIMER (Fase 1 desacople) ========= */
  var cfCloseTimer = null;

  /* ========= REVERT SYSTEM (v17.5 AUDITED) ========= */
  window.cfMenuRevert = function () {
    var S = window.__cfm17_state;
    if (!S) return;
    try {
      document.getElementById('cfm17-root')?.remove();

      if (S.listeners?.length) {
        S.listeners.forEach(function (o) {
          try { o.target?.removeEventListener(o.type, o.fn, o.opts); } catch (e) {}
        });
      }
      if (S.drawerChildren) {
        S.drawerChildren.forEach(function (o) { if (o.el?.style) o.el.style.display = o.display; });
      }
      if (S.mutations) {
        S.mutations.forEach(function (o) {
          if (!o.el?.style) return;
          if (o.value == null) o.el.style.removeProperty(o.prop);
          else o.el.style.setProperty(o.prop, o.value, o.priority || '');
        });
      }
      if (S.backdrops) {
        S.backdrops.forEach(function (o) { if (o.el) o.el.style.cssText = o.css || ''; });
      }
      if (S.bodyLock) {
        var b = S.bodyLock;
        document.body.style.overflow = b.overflow;
        document.body.style.position = b.position;
        document.body.style.top = b.top;
        document.body.style.width = b.width;
        document.documentElement.style.overscrollBehavior = b.osb;
        var prevSB = document.documentElement.style.scrollBehavior;
        document.documentElement.style.scrollBehavior = 'auto';
        window.scrollTo(0, b.scrollY);
        document.documentElement.style.scrollBehavior = prevSB;
      }
      if (S.focusRestoreEl?.focus) {
        try { S.focusRestoreEl.focus({ preventScroll: true }); } catch (e) {}
      }
      /* Limpiar timer de cierre si quedó pendiente */
      if (cfCloseTimer) { clearTimeout(cfCloseTimer); cfCloseTimer = null; }
    } catch (e) { console.warn('[COVRFLY] revert error', e); }
    finally { window.__cfm17_state = null; }
  };

  /* ========= OPEN FUNCTION ========= */
  function cfMenuOpen() {
    if (typeof window.cfMenuRevert === 'function') window.cfMenuRevert();

    /* ========= FIND SHOPIFY DRAWER ========= */
    var header = document.querySelector('.offcanvas-header')
      || document.querySelector('.header__menu_drawer')
      || document.querySelector('details[open] > div');
    if (!header) { console.error('[COVRFLY] No drawer header found'); return; }
    var offcanvas = header.closest('.offcanvas') || header.closest('details') || header.parentElement;
    var origClose = header.querySelector('.offcanvas__close_btn')
      || header.querySelector('button[aria-label="Close"]')
      || header.querySelector('summary')
      || offcanvas?.querySelector('.offcanvas__close_btn')
      || document.querySelector('[data-close],.offcanvas__close_btn,button[aria-label="Close"]');

    /* ========= STATE TRACKING (v17.5) ========= */
    var state = {
      drawerChildren: [], mutations: [], backdrops: [],
      bodyLock: null, listeners: [],
      focusRestoreEl: document.activeElement,
      closing: false
    };
    window.__cfm17_state = state;

    var on = function (target, type, fn, opts) {
      if (!target) return;
      target.addEventListener(type, fn, opts);
      state.listeners.push({ target: target, type: type, fn: fn, opts: opts });
    };

    var mut = function (el, prop, val, pri) {
      if (!el?.style) return;
      state.mutations.push({ el: el, prop: prop, value: el.style.getPropertyValue(prop) || null, priority: el.style.getPropertyPriority(prop) || '' });
      if (val == null) el.style.removeProperty(prop);
      else el.style.setProperty(prop, val, pri || '');
    };

    /* R4-1: XSS escape helpers */
    var esc = function (s) { return String(s ?? '').replace(/[&<>"']/g, function (t) { return ({ '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' })[t]; }); };
    var safeUrl = function (u) { var s = String(u ?? ''); return (s.startsWith('/') || s.startsWith('https://')) ? s : '#'; };
    /* R5-1: Sanitize collection handles for href attributes */
    var safeHandle = function (h) { return String(h ?? '').toLowerCase().trim().replace(/[^a-z0-9-]/g, ''); };
    /* R6-1: Safe CSS url() — quotes + escapes " to prevent style injection */
    var cssUrl = function (u) { return "url('" + safeUrl(String(u ?? '')).replace(/'/g, '%27') + "')"; };

    /* Hide drawer children */
    Array.from(header.children).forEach(function (c) {
      state.drawerChildren.push({ el: c, display: c.style.display });
      c.style.display = 'none';
    });

    if (offcanvas) {
      mut(offcanvas, 'background', 'transparent', 'important');
      mut(offcanvas, 'box-shadow', 'none', 'important');
      mut(offcanvas, 'overflow', 'visible', 'important');
      mut(offcanvas, 'pointer-events', 'none', 'important');
    }

    document.querySelectorAll('.offcanvas-backdrop,.offcanvas-overlay,.drawer__overlay,.modal-overlay').forEach(function (bd) {
      state.backdrops.push({ el: bd, css: bd.style.cssText });
      bd.style.opacity = '0';
      bd.style.pointerEvents = 'none';
    });

    /* ========= SCROLL LOCK ========= */
    var scrollY = window.scrollY || 0;
    state.bodyLock = {
      scrollY: scrollY,
      overflow: document.body.style.overflow,
      position: document.body.style.position,
      top: document.body.style.top,
      width: document.body.style.width,
      osb: document.documentElement.style.overscrollBehavior
    };
    document.documentElement.style.overscrollBehavior = 'none';
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + scrollY + 'px';
    document.body.style.width = '100%';

    on(document, 'touchmove', function (e) {
      var root = document.getElementById('cfm17-root');
      if (!root) return;
      if (!e.target.closest('.cfm17-bd')) e.preventDefault();
    }, { passive: false });

    /* ========= CONFIG (editable desde customizer) ========= */
    var cfm17Config = (function () {
      try {
        var el = document.getElementById('cfm17-config');
        return el ? JSON.parse(el.textContent) : {};
      } catch (e) { return {}; }
    })();

    /* ========= ASSETS ========= */
    var creaGIF = cfm17Config.cardRightImage || cfm17Config.customizeGif || 'https://cdn.shopify.com/s/files/1/0741/3510/9868/files/covrfly-crea-tu-propia-funda-ezgif.com-gif-to-webp-converter.webp?v=1772002034';
    var HERO = [cfm17Config.hero1 || 'best-sellers', cfm17Config.hero2 || 'new-drops'];
    var HERO_CUSTOM = [cfm17Config.hero1Image || null, cfm17Config.hero2Image || null];
    var customizeHref = '/products/' + (cfm17Config.customizeProduct || 'covrfly');
    var resize = function (u, w) { return u ? (u.includes('?') ? u + '&width=' + w : u + '?width=' + w) : ''; };

    var SVG = {
      close: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>',
      search: '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="9.2" cy="9.2" r="7"/><line x1="14.2" y1="14.2" x2="18" y2="18" stroke-linecap="round"/></svg>',
      user: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>',
      back: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>',
      chevron: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>',
      arrow: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>',
      pin: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/></svg>'
    };

    /* ========= ACCOUNT CARD COPY (contextual) ========= */
    var acctLoggedIn = !!cfm17Config.customerLoggedIn;
    var acctNameRaw = cfm17Config.customerName || '';
    var acctTitle = (acctLoggedIn && acctNameRaw)
      ? 'Hola, ' + esc(acctNameRaw)
      : 'Mi cuenta';
    var acctHref = acctLoggedIn ? '/account' : '/account/login';

    /* ========= HTML ========= */
    var root = document.createElement('div');
    root.id = 'cfm17-root';
    root.setAttribute('role', 'presentation');
    root.innerHTML =
      '<div id="cfm17-scrim" aria-hidden="true"></div>' +
      '<div class="cfm17-panel" role="dialog" aria-modal="true" aria-label="Menú de navegación">' +
        '<div class="cfm17-topbar">' +
          '<button class="cfm17-btn" id="cfm17-x" aria-label="Cerrar menú">' + SVG.close + '</button>' +
        '</div>' +

        '<button type="button" class="cfm17-srch" id="cfm17-srch" aria-label="Buscar">' + SVG.search + '<span>Buscar...</span></button>' +

        '<div class="cfm17-bd">' +
          '<div class="cfm17-sticky cfm17-an cfm17-d1">' +
            '<a href="/apps/parcelpanel" class="cfm17-track" aria-label="Rastrea tu pedido">' +
              '<div class="cfm17-track-top">' +
                '<div class="cfm17-track-ico">' +
                  '<div class="cfm17-track-live"></div>' +
                  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round"><path d="M16.5 9.4L7.5 4.21"/><path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22" x2="12" y2="12"/></svg>' +
                '</div>' +
                '<div class="cfm17-track-txt">' +
                  '<div class="cfm17-track-title">Rastrea tu pedido</div>' +
                  '<div class="cfm17-track-sub">Tu envío, en tiempo real</div>' +
                '</div>' +
              '</div>' +
              '<div class="cfm17-track-route">' +
                '<div class="cfm17-track-progress"><div class="cfm17-track-progress-fill"></div></div>' +
                '<div class="cfm17-track-labels"><span>Enviado</span><span>En camino</span><span>Entregado</span></div>' +
              '</div>' +
            '</a>' +
          '</div>' +
          '<div class="cfm17-cards cfm17-an cfm17-d2">' +
            '<a href="/collections/' + HERO[0] + '" class="cfm17-card cfm17-card--hero" aria-label="Colección destacada"><div class="cfm17-card-bg ld" id="cfm17-h0"></div></a>' +
            '<div class="cfm17-card-row">' +
              '<a href="/collections/' + HERO[1] + '" class="cfm17-card cfm17-card--sm" aria-label="Colección secundaria"><div class="cfm17-card-bg ld" id="cfm17-h1"></div></a>' +
              '<a href="' + customizeHref + '" class="cfm17-card cfm17-card--sm cfm17-card--gif" aria-label="Personaliza tu funda"><div class="cfm17-card-bg" style="background-image:url(' + creaGIF + ')"></div></a>' +
            '</div>' +
          '</div>' +

          '<div class="cfm17-label cfm17-an cfm17-d3">Colecciones</div>' +
          '<div class="cfm17-cg cfm17-an cfm17-d3" id="cfm17-grid" role="list"></div>' +

          '<div class="cfm17-promo cfm17-an cfm17-d4">' +
          '<div class="cfm17-promo-glow"></div>' +
          '<div class="cfm17-promo-sweep"><div class="cfm17-promo-sweep-inner"></div></div>' +
          '<div class="cfm17-promo-sub">Compra 2 o más</div>' +
          '<div class="cfm17-promo-hero">hasta 25% <span class="cfm17-promo-off">OFF</span></div>' +
          '<div class="cfm17-promo-free"><div class="cfm17-promo-dot"></div><span>envío sin costo</span></div>' +
          '<div class="cfm17-promo-sep"></div>' +
          '<div class="cfm17-promo-tiers">' +
          '<div class="cfm17-tier cfm17-tier--1"><div class="cfm17-tier-pct">15%</div><div class="cfm17-tier-qty">2</div></div>' +
          '<div class="cfm17-tier cfm17-tier--2"><div class="cfm17-tier-pct">20%</div><div class="cfm17-tier-qty">3</div></div>' +
          '<div class="cfm17-tier cfm17-tier--3"><div class="cfm17-tier-badge">mejor</div><div class="cfm17-tier-pct">25%</div><div class="cfm17-tier-qty">4+</div></div>' +
          '</div>' +
          '</div>' +

          '<a href="' + acctHref + '" class="cfm17-acct cfm17-an cfm17-d5">' +
            '<div class="cfm17-acct-ico">' +
              '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
                '<path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>' +
                '<circle cx="12" cy="7" r="4"/>' +
              '</svg>' +
            '</div>' +
            '<div class="cfm17-acct-title">' + acctTitle + '</div>' +
            '<svg class="cfm17-acct-arrow" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
              '<path d="M9 18l6-6-6-6"/>' +
            '</svg>' +
          '</a>' +
        '</div>' +
      '</div>';

    document.body.appendChild(root);

    /* Apply custom hero images synchronously (skip fetch wait) */
    HERO_CUSTOM.forEach(function (customSrc, i) {
      if (!customSrc) return;
      var el = document.getElementById('cfm17-h' + i);
      if (el) { el.style.backgroundImage = cssUrl(customSrc); el.classList.remove('ld'); }
    });

    /* ========= SWIPE-TO-CLOSE (premium, Apple-style) =========
       - Direction lock con ángulo dominante (scroll vertical protegido)
       - Real-time tracking (panel sigue el dedo)
       - Threshold: 30% del ancho OR velocity -0.5 px/ms
       - Scrim opacity proporcional
       - Rubber-band back si no llega al threshold
       - Integrado con state.listeners (cleanup automático en cfMenuRevert) */
    var swipePanel = document.querySelector('.cfm17-panel');
    var swipeScrim = document.getElementById('cfm17-scrim');
    if (swipePanel && swipeScrim) {
      var SWIPE_DIR_LOCK_PX = 8;
      var SWIPE_CLOSE_DIST_RATIO = 0.30;
      var SWIPE_CLOSE_VELOCITY = -0.5; /* px/ms, leftward */
      var swipe = null; /* { x0, y0, dir, lastX, lastT, vX, panelW, killedAnim } */

      var swipeReset = function () {
        if (!swipePanel) return;
        swipePanel.style.transition = 'transform .28s cubic-bezier(.2,.8,.2,1), opacity .28s ease';
        swipeScrim.style.transition = 'opacity .28s ease';
        /* FIX iOS Safari quirk: sin forced reflow, el browser batcha los
           cambios (transition: none → .28s + transform en mismo task) y NO
           dispara la transición, dejando el panel atorado en la posición
           donde lo dejaste. Leer offsetHeight fuerza el commit del nuevo
           valor de transition antes de procesar el cambio de transform. */
        void swipePanel.offsetHeight;
        swipePanel.style.transform = 'translateX(0)';
        swipePanel.style.opacity = '1';
        swipeScrim.style.opacity = '1';
        setTimeout(function () {
          if (state.closing) return;
          /* Limpiar todas las inline styles tras la rubber-band para dejar
             el panel en estado "pristine" (listo para otro swipe). */
          swipePanel.style.transition = '';
          swipePanel.style.transform = '';
          swipePanel.style.opacity = '';
          swipePanel.style.animation = '';
          swipeScrim.style.transition = '';
          swipeScrim.style.opacity = '';
        }, 320);
      };

      var swipeCloseAnim = function () {
        if (state.closing) return;
        state.closing = true;
        swipePanel.style.transition = 'transform .22s cubic-bezier(.4,0,1,1), opacity .22s ease';
        swipeScrim.style.transition = 'opacity .22s ease';
        /* FIX iOS Safari: forced reflow (ver swipeReset) */
        void swipePanel.offsetHeight;
        swipePanel.style.transform = 'translateX(-100%)';
        swipePanel.style.opacity = '0';
        swipeScrim.style.opacity = '0';
        cfCloseTimer = setTimeout(function () {
          cfCloseTimer = null;
          if (typeof window.cfMenuRevert === 'function') window.cfMenuRevert();
        }, 220);
      };

      on(swipePanel, 'touchstart', function (e) {
        if (state.closing) return;
        if (!e.touches || e.touches.length !== 1) { swipe = null; return; }
        var t = e.touches[0];
        swipe = {
          x0: t.clientX, y0: t.clientY,
          dir: null,
          lastX: t.clientX, lastT: performance.now(), vX: 0,
          panelW: swipePanel.offsetWidth,
          killedAnim: false
        };
      }, { passive: true });

      on(swipePanel, 'touchmove', function (e) {
        if (!swipe || state.closing) return;
        if (!e.touches || e.touches.length !== 1) { swipe = null; return; }
        var t = e.touches[0];
        var dx = t.clientX - swipe.x0;
        var dy = t.clientY - swipe.y0;
        var absDx = Math.abs(dx), absDy = Math.abs(dy);

        /* Direction lock (una sola vez) */
        if (!swipe.dir) {
          if (absDx < SWIPE_DIR_LOCK_PX && absDy < SWIPE_DIR_LOCK_PX) return;
          if (absDy >= absDx || dx >= 0) {
            /* Vertical O rightward → liberar gesto, scroll natural */
            swipe.dir = 'v';
            return;
          }
          /* Horizontal leftward → capturar */
          swipe.dir = 'h';
          swipePanel.style.animation = 'none';  /* matar cfm17slideIn si corre */
          swipePanel.style.transition = 'none';
          swipeScrim.style.transition = 'none';
          swipe.killedAnim = true;
        }

        if (swipe.dir !== 'h') return;

        /* Velocity — ventana corta, últimos frames */
        var now = performance.now();
        var dtv = now - swipe.lastT;
        if (dtv > 0) {
          swipe.vX = (t.clientX - swipe.lastX) / dtv;
          swipe.lastX = t.clientX;
          swipe.lastT = now;
        }

        /* Clamp: solo leftward, max -panelW */
        var clampedDx = Math.max(-swipe.panelW, Math.min(0, dx));
        var progress = Math.abs(clampedDx) / swipe.panelW;

        swipePanel.style.transform = 'translateX(' + clampedDx + 'px)';
        swipePanel.style.opacity = String(1 - progress * 0.4);  /* fade sutil, matches cfm17slideIn */
        swipeScrim.style.opacity = String(1 - progress);

        /* Bloquear scroll vertical mientras estamos lockeados horizontal */
        if (e.cancelable) e.preventDefault();
      }, { passive: false });

      on(swipePanel, 'touchend', function (e) {
        if (!swipe) return;
        if (swipe.dir !== 'h') { swipe = null; return; }
        var t = (e.changedTouches && e.changedTouches[0]) || null;
        var dx = t ? (t.clientX - swipe.x0) : 0;
        var clampedDx = Math.max(-swipe.panelW, Math.min(0, dx));
        var progress = Math.abs(clampedDx) / swipe.panelW;
        var shouldClose = progress >= SWIPE_CLOSE_DIST_RATIO || swipe.vX <= SWIPE_CLOSE_VELOCITY;
        swipe = null;
        if (shouldClose) swipeCloseAnim();
        else swipeReset();
      }, { passive: true });

      on(swipePanel, 'touchcancel', function () {
        if (!swipe) return;
        if (swipe.dir === 'h') swipeReset();
        swipe = null;
      }, { passive: true });
    }

    /* ========= CLOSE WITH EXIT ANIMATION (Fase 1 desacople — cierre propio) ========= */
    var doClose = function () {
      if (state.closing) return;
      state.closing = true;

      var panel = document.querySelector('.cfm17-panel');
      var scrim = document.getElementById('cfm17-scrim');
      if (panel) panel.classList.add('is-closing');
      if (scrim) scrim.classList.add('is-closing');

      /* Cierre propio — NO hacer click al botón de Rivon */
      cfCloseTimer = setTimeout(function () {
        cfCloseTimer = null;
        if (typeof window.cfMenuRevert === 'function') {
          window.cfMenuRevert();
        }
      }, 300);
    };

    on(document.getElementById('cfm17-x'), 'click', doClose);

    on(document.getElementById('cfm17-scrim'), 'click', doClose);

    /* ESC + Focus trap */
    on(window, 'keydown', function (e) {
      if (e.key === 'Escape') {
        doClose();
        return;
      }

      /* R4-3: Focus trap filters invisible elements */
      if (e.key === 'Tab') {
        /* Guard: si el menú ya no está montado (p.ej. tras delegar a la lupita), liberar el trap */
        if (!document.getElementById('cfm17-root')) return;
        var panel = document.querySelector('.cfm17-panel');
        if (!panel) return;
        var focusable = Array.from(panel.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),[tabindex]:not([tabindex="-1"])'))
          .filter(function (el) { return el.offsetWidth > 0 && el.offsetHeight > 0 && window.getComputedStyle(el).visibility !== 'hidden'; });
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        /* R5-2: Catch focus that escaped the panel (Safari, timing, widgets) */
        if (!panel.contains(document.activeElement)) {
          e.preventDefault();
          (e.shiftKey ? last : first).focus({ preventScroll: true });
          return;
        }
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault(); last.focus({ preventScroll: true });
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault(); first.focus({ preventScroll: true });
        }
      }
    });

    /* ========= SEARCH — delegación a la lupita del header (Variante E: Zero-flash handoff) =========
       3 bugs resueltos:

       (1) iOS gesture chain: btn.click() + input.focus() SÍNCRONOS dentro del handler
           del tap. Si se envuelven en setTimeout/rAF, iOS NO muestra el teclado.

       (2) Flash del homepage: el menú (.cfm17-panel, z-index 2147483000) está ENCIMA de
           la lupita (#predictive__search_overlay, z-index 99999). Si fade-eamos el menú a 0
           mientras la lupita hace fade-in, durante la transición AMBOS son parcialmente
           transparentes y el glass no llega a ocluir el homepage → fogonazo visible.
           Solución: el menú NO se fadea. Permanece 100% opaco, cubriendo el homepage,
           MIENTRAS la lupita hace su fade-in por debajo (invisible para el usuario).
           Cuando la lupita está 100% visible (≥280ms), cfMenuRevert() destruye el menú
           de golpe — y como ambos paneles son pixel-perfect idénticos, el swap es invisible.

       (3) cfMenuRevert() llama S.focusRestoreEl.focus() (el botón hamburguesa) → roba
           focus del input → teclado desaparece. Solución: anular focusRestoreEl antes
           de cfMenuRevert para evitar el focus-stealing.
    */
    var openSearch = function () {
      var panel = document.querySelector('.cfm17-panel');
      if (!panel) return;

      /* 0. Marcar modal como apertura desde menú:
         (a) activa modo fade-only en cf-predictive.js (CSS .from-menu)
         (b) activa rama from-menu en search-modal.js open() → trapFocus enfoca input
         + MutationObserver que limpia la clase cuando el modal se cierra */
      var modal = document.querySelector('search-modal');
      if (modal) {
        modal.classList.add('from-menu');
        try {
          var cleanup = new MutationObserver(function () {
            if (!modal.classList.contains('active')) {
              modal.classList.remove('from-menu');
              cleanup.disconnect();
            }
          });
          cleanup.observe(modal, { attributes: true, attributeFilter: ['class'] });
        } catch (e) {}
      }

      /* 1. Bloquear interacción con el menú durante el handoff (NO fade — el menú cubre
            el homepage mientras la lupita se monta por debajo) */
      panel.style.pointerEvents = 'none';

      /* 2. SÍNCRONO: abrir modal + enfocar input (iOS gesture chain vivo) */
      try {
        var btn = document.getElementById('header_search__action');
        if (btn) {
          btn.click();
          var inp = document.getElementById('Search-In-Modal') || document.querySelector('input.search__input');
          if (inp) {
            try { inp.focus({ preventScroll: true }); } catch (_) {
              try { inp.focus(); } catch (__) {}
            }
          }
        } else {
          /* FALLBACK 1: abrir modal manualmente + focus forzado al input */
          var m = document.querySelector('search-modal');
          if (m && typeof m.open === 'function') {
            m.open(null);
            var inp2 = document.getElementById('Search-In-Modal') || document.querySelector('input.search__input');
            if (inp2) {
              try { inp2.focus({ preventScroll: true }); } catch (_) {
                try { inp2.focus(); } catch (__) {}
              }
            }
          } else {
            /* FALLBACK 2: página de búsqueda */
            window.location.href = '/search';
            return;
          }
        }
      } catch (e) {
        window.location.href = '/search';
        return;
      }

      /* 3. Esperar a que la lupita esté 100% visible (fade CSS dura 250ms desde cf-predictive.js)
            y DESPUÉS destruir el menú. Antes de revert, anular focusRestoreEl para que
            cfMenuRevert no robe el focus del input (y con él, el teclado). */
      setTimeout(function () {
        try {
          if (window.__cfm17_state) window.__cfm17_state.focusRestoreEl = null;
        } catch (e) {}
        if (typeof window.cfMenuRevert === 'function') window.cfMenuRevert();
      }, 300);
    };

    on(document.getElementById('cfm17-srch'), 'click', openSearch);

    /* R4-4: Search pill responds to Enter/Space */
    on(document.getElementById('cfm17-srch'), 'keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        openSearch();
      }
    });

    var srch = document.getElementById('cfm17-srch');
    setTimeout(function () { try { srch?.focus?.({ preventScroll: true }); } catch (e) {} }, 80);

    /* ========= COLLECTIONS ========= */
    var fetchWithTimeout = function (url, ms) {
      var ac = new AbortController();
      var t = setTimeout(function () { ac.abort(); }, ms);
      return fetch(url, { credentials: 'same-origin', signal: ac.signal })
        .finally(function () { clearTimeout(t); });
    };

    var collectionsPromise = prefetchedCollections
      ? Promise.resolve(prefetchedCollections)
      : fetchWithTimeout('/collections.json?limit=30', 4000).then(function (r) { return r.json(); });

    collectionsPromise.then(function (data) {
        if (!document.getElementById('cfm17-root')) return;
        var colls = data?.collections || [];
        var map = {};
        colls.forEach(function (c) { map[c.handle] = c; });

        HERO.forEach(function (h, i) {
          var el = document.getElementById('cfm17-h' + i);
          if (!el) return;
          /* Skip fetch si el customizer proveyó imagen custom (ya se aplicó sincrónicamente al crear el DOM) */
          if (HERO_CUSTOM[i]) { el.classList.remove('ld'); return; }
          var src = map[h]?.image?.src;
          if (src) el.style.backgroundImage = cssUrl(resize(src, 800));
          else el.style.background = 'linear-gradient(135deg,#1a1a2e,#333)';
          el.classList.remove('ld');
        });

        var grid = document.getElementById('cfm17-grid');
        if (grid) {
          /* Si Oscar configuró colecciones desde el customizer → usar ESA lista (en ese orden)
             Si está vacía → FALLBACK al comportamiento automático (colls filtradas sin hero) */
          var configured = Array.isArray(cfm17Config.collections) ? cfm17Config.collections : [];
          var sub;
          if (configured.length > 0) {
            sub = configured.slice(0, 8).map(function (entry) {
              var mapped = map[entry.handle] || {};
              return {
                handle: entry.handle,
                title: entry.title || mapped.title || entry.handle,
                image: entry.image ? { src: entry.image } : mapped.image || null
              };
            });
          } else {
            sub = colls.filter(function (c) { return !HERO.includes(c.handle); }).slice(0, 7);
          }
          var gh = '';
          sub.forEach(function (c) {
            var src = c.image?.src;
            var handle = safeHandle(c.handle);
            /* R4-1: XSS — escape c.title in fallback */
            gh += src
              ? '<a href="/collections/' + handle + '" class="cfm17-co" role="listitem" aria-label="' + esc(c.title) + '"><div class="cfm17-co-bg" style="background-image:' + cssUrl(resize(src, 400)) + '"></div></a>'
              : '<a href="/collections/' + handle + '" class="cfm17-co" role="listitem" style="background:rgba(200,200,200,.5);display:flex;align-items:center;justify-content:center;font-size:12px;font-weight:700;color:#555;text-transform:uppercase">' + esc(c.title) + '</a>';
          });
          gh += '<a href="/collections" class="cfm17-vt" role="listitem" aria-label="Ver todas las colecciones"><div class="cfm17-vt-ico">' + SVG.arrow + '</div><span>Ver todas</span></a>';
          grid.innerHTML = gh;
        }
      }).catch(function (e) {
        if (e.name === 'AbortError') console.warn('[COVRFLY] collections fetch timeout (4s)');
        else console.warn('[COVRFLY] collections error', e);
      });
  }

  window.cfMenuOpen = cfMenuOpen;

  /* ========= PREFETCH COLLECTIONS ========= */
  var prefetchedCollections = null;

  function prefetchCollections() {
    fetch('/collections.json?limit=30', { credentials: 'same-origin' })
      .then(function(r) { return r.json(); })
      .then(function(data) { prefetchedCollections = data; })
      .catch(function() {});
  }

  // Prefetch después de 1 segundo (no bloquear carga inicial de la página)
  setTimeout(prefetchCollections, 1000);

  /* ========= INTERCEPT HAMBURGER (Fase 1 desacople) ========= */
  function initMenuIntercept() {
    document.addEventListener('click', function(e) {
      var hamburger = e.target.closest('.header__actions_btn--menu');
      if (!hamburger) return;

      // Interceptar ANTES de que mobile-nav.js procese el click
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      // Guard: si el menú ya está abierto, no reabrir
      if (document.getElementById('cfm17-root')) return;

      // Cancelar cualquier cierre pendiente
      if (cfCloseTimer) {
        clearTimeout(cfCloseTimer);
        cfCloseTimer = null;
      }

      // Cerrar cualquier <details> nativo abierto (defensa contra <summary>)
      document.querySelectorAll('details[open]').forEach(function(d) { d.open = false; });

      // Abrir menú premium directamente — sin polling, sin esperar Rivon
      try {
        cfMenuOpen();
      } catch(err) {
        console.error('[COVRFLY] menu open error', err);
      }
    }, true); // capture: true — se ejecuta antes que mobile-nav.js
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMenuIntercept);
  } else {
    initMenuIntercept();
  }
})();
